module.exports = __webpack_public_path__ + "media/images/logo-small-ab1ce8b14a24661d0b68b0fca64b79c6.png";